import React from 'react'
import { string, node } from 'prop-types'
import { withRouter } from 'react-router'
import { Button } from '@planningcenter/tapestry-react'

const LinkButton = ({
  history,
  to,
  onClick,
  size = 'md',
  variant = 'fill',
  theme = 'primary',
  children,
  ...rest
}) => {
  return (
    <Button
      theme={theme}
      variant={variant}
      onClick={event => {
        onClick && onClick(event)
        history.push(to)
      }}
      size={size}
      {...rest}
    >
      {children ? children : null}
    </Button>
  )
}

LinkButton.propTypes = {
  to: string.isRequired,
  children: node,
}

export default withRouter(LinkButton)
